import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

// Locale-aware equivalents of next/link and next/navigation — Link
// automatically prefixes hrefs with the current/target locale.
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
